import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Check } from "lucide-react";
import Reveal from "./Reveal";
import { IMAGES } from "@/data/content";

const SERVICES = [
  "Wedding Catering",
  "Corporate Catering",
  "Birthday Parties",
  "Private Events",
  "Family Gatherings",
  "Festivals",
];

export default function Catering() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "14%"]);

  return (
    <section id="catering" ref={ref} data-testid="catering-section" className="relative overflow-hidden py-28 md:py-40 px-6 md:px-10 border-t border-[#C8A24A]/10">
      <motion.img style={{ y, scale: 1.2 }} src={IMAGES.spices} alt="Catering" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-[#0D0D0D]/85" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0D0D0D] via-[#0D0D0D]/70 to-transparent" />

      <div className="relative z-10 mx-auto max-w-[1400px] grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <Reveal>
            <p className="text-[#C8A24A] uppercase text-xs tracking-[0.35em] mb-4">Catering & Events</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-tight">
              Bring Ekaa to <br /><span className="italic text-gold-gradient">Your Celebration</span>
            </h2>
            <p className="mt-6 text-[#D6D6D6] font-light max-w-lg leading-relaxed">
              From intimate family gatherings to grand weddings, our team crafts bespoke
              menus and impeccable service that turn any occasion into a golden memory.
            </p>
          </Reveal>

          <div className="mt-10 grid sm:grid-cols-2 gap-4 max-w-lg">
            {SERVICES.map((s, i) => (
              <Reveal key={s} delay={i * 0.06} className="flex items-center gap-3">
                <span className="h-6 w-6 flex items-center justify-center rounded-full border border-[#C8A24A] text-[#C8A24A]">
                  <Check className="h-3.5 w-3.5" />
                </span>
                <span className="text-[#D6D6D6]">{s}</span>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2}>
            <a href="#contact" data-testid="catering-enquire-btn" className="btn-gold inline-block mt-11 bg-gradient-to-r from-[#C8A24A] to-[#E0C067] text-[#0D0D0D] px-9 py-3.5 rounded-sm text-sm tracking-[0.16em] uppercase font-semibold">
              Enquire Now
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
